import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpEvent,
  HttpErrorResponse, HttpInterceptorFn, HttpHandlerFn
} from '@angular/common/http';
import {
  catchError,
  Observable,
  switchMap,
  throwError
} from 'rxjs';
import { AuthService } from "./auth.service";
import { CognitoService } from './cognito.service';

// export const unauthInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
//   const authService = inject(AuthService);

//   return next(request)
//     .pipe(
//       catchError((error) => {
//         if (error instanceof HttpErrorResponse && error.status === 401) {
//           const { refresh_token } = authService.loggedInUser;
//           if (refresh_token) {
//             return authService.refresh(refresh_token)
//               .pipe(
//                 switchMap((value) => next(request.clone({
//                   headers: request.headers.set('Authorization', `Bearer ${ value.access_token }`)
//                 })))
//               );
//           }
//         }

//         return throwError(() => error);
//       })
//     );
// }

export const unauthInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const cognitoService = inject(CognitoService);

  return next(request)
    .pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          cognitoService.refreshToken()
          .then(() => {
            cognitoService.fetchUserInfo();
          })
        }

        return throwError(() => error);
      })
    );
}

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  // const authService = inject(AuthService);
  const cognitoService = inject(CognitoService);
  let req = request.clone();

  if(cognitoService.isUserLogged && !req.url.includes('AWSAccessKeyId')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${ cognitoService.accessToken?.toString() }`
      }
    });
  }
  else {
  }

  // if (authService.loggedInUser !== null) {
  //   req = req.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${ authService.loggedInUser.access_token }`
  //     }
  //   });
  // }

  return next(req)
    .pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
}
